module.exports = __webpack_public_path__ + "img/icone-sucesso.0a784898.svg";